import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Transformation } from '../components/sections/Transformation';
import { Pains } from '../components/sections/Pains';
import { Volumes } from '../components/sections/Volumes';
import { Toolkits } from '../components/sections/Toolkits';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { Author } from '../components/sections/Author';
import { Faq } from '../components/sections/Faq';
import { FinalCta } from '../components/sections/FinalCta';
import { FloatingCta } from '../components/FloatingCta';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-312" data-mp="3qqjmcccd5xve">
      <Hero data-id="element-313" data-mp="3vo2xv4hofwjn" />
      <main data-id="element-314" data-mp="3vntg246scvp1">
        <Transformation data-id="element-315" data-mp="3vpe215f1b6ba" />
        <Pains data-id="element-316" data-mp="3ajggcvcu3hww" />
        <Volumes data-id="element-317" data-mp="3ak8a00mvf5kj" />
        <Toolkits data-id="element-318" data-mp="3akrt3ko9c005" />
        <Bonuses data-id="element-319" data-mp="3alb5klv51w6s" />
        <Offer data-id="element-320" data-mp="3alt4jq96qoie" />
        <Guarantee data-id="element-321" data-mp="35t04hfonw4cn" />
        <Testimonials data-id="element-322" data-mp="35si1m07hurvr" />
        <Author data-id="element-323" data-mp="35s8842n8q2lb" />
        <Faq data-id="element-324" data-mp="35royrabnomiw" />
        <FinalCta data-id="element-325" data-mp="35qx6o9h9p6xd" />
      </main>
      <footer className="bg-ink px-4 pb-28 pt-8 text-center sm:pb-10" data-id="element-326" data-mp="30tdpb0p9we17">
        <div className="mx-auto max-w-5xl border-t border-ink-line pt-8" data-id="element-327" data-mp="30rkgber6thq1">
          <p className="font-serif text-lg font-black text-gold" data-id="element-328" data-mp="2vwnasht49qhw">Picking Control 30™</p>
          <p className="mt-1 text-sm text-white/60" data-id="element-329" data-mp="3ti2i8cg6dd1v">© 2026 · Jack Miller · Picking Control 30™ · All rights reserved.</p>
        </div>
      </footer>
      <FloatingCta data-id="element-330" data-mp="3jkepfs24qfmc" />
      <PurchasePopup data-id="element-331" data-mp="3jjn2t6qifs87" />
    </div>;
}